import { Base } from "ui/Scripts/source/framework/base";
import { FrontToDoItemGroup, IFrontToDoItemGroup } from "./frontToDoItemGroup";

export interface IFrontToDoItemGroups {
    groups: IFrontToDoItemGroup[];
}

export class FrontToDoItemGroups implements IFrontToDoItemGroups {
    groups: FrontToDoItemGroup[];

    constructor();
    constructor(obj: IFrontToDoItemGroup);
    constructor(obj?: any) {
        this.groups = Base.getTypedArray(obj ? obj.groups : null, FrontToDoItemGroup);
    }
}